import type { DataTableColumn } from '@/components/custom/erp';
import type { TinhChatThue } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<TinhChatThue>[] => [
  {
    field: 'ma_tc_thue',
    headerName: 'Mã tính chất thuế',
    width: 150
  },
  {
    field: 'ten_tc_thue',
    headerName: 'Tên tính chất thuế',
    width: 250
  }
];
